import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import "datatables.net";
import "datatables.net-responsive";
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/react-confirm-alert/react-confirm-alert.css";
import { Link, Redirect } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import "./css/ipos-navbar.css";
import "./css/TotalEMI.css";
import TopNavbar from "ipos/js/TopNavbar";
import MobNavbar from "./js/BottomNav";
import { isMobile } from "react-device-detect";
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
import jwt_decode from "jwt-decode";
import { Modal } from "react-responsive-modal";
import { Button } from 'react-bootstrap';
import EchargeSlip from './js/eChargeSlip'
import {connect}  from  "react-redux";




let userdetail = {
  userName: '',
  sessionId: '',
  merchantId: '',
  activeTerminal: 'All Terminals',
  allTerminals: [],
  currPage:'',
}
//const chargeslipurl="https://totalemi.innoviti.com:30011/eslip/C000260120200319194816651223224072215";
const override = css`
    position:absolute;
    display: block;
    margin-left:45%;
    margin-top:200px;
    border-color: red;
    text-align: center;
`;
let phoneno;
const getCardLabelIcons = cardLabel => {
  const icons = [
    {
      key: "AMEX",
      value: require("../assets/img/cards/amex_icon.png")
    },
    {
      key: "MASTERCARD",
      value: require("../assets/img/cards/mastercard_icon.png")
    },
    {
      key: "RUPAY",
      value: require("../assets/img/cards/rupay_icon.png")
    },
    {
      key: "SODEXO",
      value: require("../assets/img/cards/sodexo_icon.png")
    },
    {
      key: "VISA",
      value: require("../assets/img/cards/visa_card_icon.png")
    },
    {
      key: "UNKNOWN",
      value: require("../assets/img/cards/unknownCard.png")
    },
    {
      key: "AMERICAN EXPRESS",
      value: require("../assets/img/cards/amex_icon.png")
    },
    {
      key: "UPI",
      value: require("../assets/img/cards/upi.png")
    }
  ];
  let icon = icons.find(icon => icon.key === cardLabel.toUpperCase());
  return icon ? icon.value : require("../assets/img/cards/unknownCard.png");
  //Sending default VISA card icon only
};

// const getStatus = status => {
//   return status === 'APPROVED' ?
//     require("../../../../assets/small_tick_green.png") :
//     require("../../../../assets/red_exclamation.png")
// }
const closeIcon = (
  <svg fill="currentColor" viewBox="0 0 0 0" width={0} height={0}>
    <path
      fillRule="evenodd"
      d=""
      clipRule="evenodd"
    ></path>
  </svg>
)
const eSlipCloseIcon = (
  <svg class="bi bi-x-square" width="2em" height="2.2em" viewBox="0 0 16 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  {/* <path fill-rule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/> */}
  <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
  <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
</svg>

)


class IposDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      name: "React",
      orgamt: { color: "darkorange" },
      orglbl: { color: "darkorange" },
      loader: false,
      terminalData: [],
      terminalNames: [],
      zeroCostBrandEmiLimit: {
        terminal: {
          dateTime: "",
          calculation: "",
          currentTime: "",
          complimentaryLimit: "",
          limitUsed: "",
          limitAvailable: "",
          yesterDayDate: "",
          nonZeroCostEMITxns: "",
          accruedLimit: ""
        }
      },
      unSettledTxn: {
        dateTime: "",
        amount: "",
        isBrandCommission: false,
        processingFees: {
          cardProcessingFees: "",
          EMI: "",
          fee: "",
          monthlyRental: "",
        },
        count: "",
        gst: "",
        txnAmount: "",
      },
      lastSettlement: {
        dateTime: "",
        amount: "",
        utrNo: "",
        utrDate: "",
        isBrandCommission: false,
        processingFees: {
          cardProcessingFees: "",
          EMI: "",
          fee: "",
          monthlyRental: "",
        },
        count: "",
        gst: "",
        txnAmount: "",
      },
      todayTxn: {
        dateTime: "",
        amount: "",
        count: "",
        gst: "",
        txnAmount: "",
      },
      lastTransaction: {
        transactionType: "",
        dateTime: "",
        amount: "",
        maskCardNumber: "",
        cardLabel: "",
        echargeSlipUrl: "",
        utid: "",
        txnId: "",
        status: "",
      },
      eSlipUri:'',
      userName: '',
      sessionId: '',
      merchantId: '',
      currTerminal: "All Terminals",
      allTerminals: [],
      selectedradio: '',
      TermModal: false,
      SlipModal:false,
    };
  }

  componentWillMount() {
   this.props.currentMenu("totalemi");
    this.fetchLoginData();
  }
  componentDidMount() {
    // this.fetchDashboardData('ALL');
  }

  fetchLoginData = () => {
    const decoded = jwt_decode(localStorage.usertoken);
    phoneno = decoded.phone;
    // let phoneno = "8009111011";
    this.setState({ loader: true })

    axios
      .post(config.get("API_URL") + "/users/totalemi-login", {
        mobileNumber: phoneno,
        password: phoneno,
        userType: "Merchant"
      })
      .then((response) => {
        if (response.data.responseCode == "00"){
          let AllTerminals = JSON.parse(JSON.stringify(this.state.allTerminals))
          response.data.responseDetails.userDetails.profile.terminals.map((value, key) => {
            AllTerminals[key] = response.data.responseDetails.userDetails.profile.terminals[key].utid;
          })
          userdetail.userName =  response.data.responseDetails.userDetails.name;
          userdetail.sessionId = response.data.responseDetails.loginSessionDetails.loginSessionId;
          userdetail.merchantId = response.data.responseDetails.userDetails.profile.merchantId;
          userdetail.appVersion = "2.1";
          userdetail.allTerminals = AllTerminals;
          // userdetail.activeTerminal = this.state.currTerminal;
          //userdetail.currPage = currentPage;
          this.setState({
            userName: response.data.responseDetails.userDetails.name,
            sessionId: response.data.responseDetails.loginSessionDetails.loginSessionId,
            merchantId: response.data.responseDetails.userDetails.profile.merchantId,

          })
          //localStorage.setItem("u_name",JSON.stringify(response.data.responseDetails.userDetails.name));
          this.fetchDashboardData(userdetail.activeTerminal);
        
          this.setState({ allTerminals: AllTerminals })

        }
        else {
          alert("User data is not onboarded on sparcs");
          // this.fetchLoginData();
        }

      });


  }
  fetchDashboardData = () => {
    this.setState({ loader: true })
    axios
      .post(config.get("API_URL") + "/users/totalemi-dashboard", {
        merchantId: this.state.merchantId.toString(),
        utid: userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal,
        loginSessionId: this.state.sessionId,
        name: this.state.userName,
        appVersion: "2.1",
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          this.setState({
            zeroCostBrandEmiLimit: response.data.responseDetails.zeroCostBrandEmiLimit,
            unSettledTxn: response.data.responseDetails.unSettledTxn,
            lastSettlement: response.data.responseDetails.lastSettlement,
            lastTransaction: response.data.responseDetails.lastTransaction,
            todayTxn: response.data.responseDetails.todayTxn,
          });
          this.setState({
            terminalData: Object.values(this.state.zeroCostBrandEmiLimit),
            terminalNames: Object.keys(this.state.zeroCostBrandEmiLimit),
            eSlipUri:response.data.responseDetails.lastTransaction.echargeSlipUrl,
            loader: false
          })
          // const termsdata=this.state.terminalData;
          // const termsname=Object.keys(this.state.zeroCostBrandEmiLimit);
          // this.state.terminalData.map((value,key)=>{
          //   console.log(this.state.terminalNames[key])
          //   console.log(this.state.terminalData[key].limitAvailable)
          // })

        }
        else {
          alert("Some technical error occured!. Please try again");
        }
      });
  };

  goBack = () => {
    this.props.history.push("/admin/brand-emi");
  };
  myCallback = (dataFromChild) => {
    let curr_dash_terminal = dataFromChild.trim().includes("All") ? "All Terminals" : dataFromChild.trim();
    this.setState({ currTerminal: curr_dash_terminal })
    userdetail.activeTerminal = curr_dash_terminal;
    this.fetchDashboardData(curr_dash_terminal);
  }

  eSlipModalCallback = () =>{
    this.setState({SlipModal:!this.state.SlipModal})
  }
  childPageClick(currentPage) {
    // userdetail.activeTerminal = this.state.currTerminal;
    userdetail.currPage = currentPage;

    if (currentPage.includes('freeemi') && this.state.allTerminals.length > 1 && userdetail.activeTerminal.includes('All')) {
      this.setState({ TermModal: true });
    }
    else {
      this.pageRedirecting();
    }

  }
  pageRedirecting = () => {
    var jwt = require('jwt-simple');
    var secret = jwt.encode(phoneno, 'innoviti');
    var token = jwt.encode(userdetail, secret);
    console.log("Encode Token" + token);
    localStorage.removeItem("UD");
    localStorage.setItem("UD", token);
    // var secret =  jwt.encode(this.state.userName, this.state.userName);
    // var decoded = jwt.decode(token, secret);
    // console.log("Decode Token"+ decoded); 
    this.props.history.push("/admin/totalemi-trans-details")
  }
  // FreeEMI model functions START
  checkterminal = (e) => {
    // console.log(e.target.outerText.trim());
    this.setState({ selectedradio: e.target.title })
  };
  onCloseModal = () => {
    this.setState({
      TermModal: false,
    })
  }
  onCloseSlipModal = () => {
    this.setState({
      SlipModal: false,
    })
  }

  applyterminal = () => {
    let selectedTerminal = this.state.selectedradio;
    userdetail.activeTerminal = selectedTerminal;
    this.setState({ currTerminal: selectedTerminal, TermModal: !this.state.TermModal, })
    this.pageRedirecting();
  }
  // FreeEMI model functions END
showChargeSlipModal =()=>{
  this.setState({SlipModal:!this.state.SlipModal})
}

  render() {

    return (
      <>
        {isMobile && <TopNavbar selectedterminals={userdetail.activeTerminal} allterminals={this.state.allTerminals} callbackFromParent={this.myCallback} />}
        {/* <h5 className="text-center">eCharge Slip</h5>
                    <iframe src="https://totalemi.innoviti.com:30011/eslip/C000260120200319194816651223224072215"
                    height="450px"
                    width="auto"
                   
                    scrolling="no"
                    /> */}
                    {/* <IframeComponent iframe={iframe}/> */}

        {this.state.loader === false ?

          <div className="fixed-content">
            
            <Modal
              open={this.state.TermModal}
              onClose={this.onCloseModal}
              closeOnOverlayClick={false}
              classNames={{
                overlay: "customOverlay",
                modal: "customModal",
              }}
              closeIcon={closeIcon}
              center
            >
              <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }}>Select Terminal</h4>
              <div style={{ padding: '0px 60px' }}>
                {/* <div onClick={this.checkterminal}>
            <input type="radio"  checked={this.state.selectedradio.includes("All")?true:false}/>
            <h5 style={{ display: 'inline-block', paddingLeft: '10px' }}>All terminals</h5>
            <br />
          </div> */}
                {this.state.allTerminals.map((terval, terkey) => {
                  return (
                    <div onClick={this.checkterminal}>
                      <input type="radio" checked={this.state.selectedradio === terval}  title={terval}/>
                      <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title={terval}> {terval} (Terminal {terkey + 1})</h5>
                      <br />
                    </div>
                  )
                })
                }

              </div>
              <div className="text-center p-5">
                <Button
                  style={{
                    background: "#ef7731",
                    color: "#fff",
                    borderRadius: "10px",
                    width: "100px",
                    margin: "5px",
                  }}
                  onClick={this.onCloseModal}
                  align="center"
                >
                  Cancel
                    </Button>
                <Button
                  style={{
                    background: "#ef7731",
                    color: "#fff",
                    borderRadius: "10px",
                    width: "100px",
                    margin: "5px",
                  }}
                  onClick={() => { this.applyterminal() }}
                  align="center"
                >
                  Apply
                    </Button>
              </div>


            </Modal>
           <Modal   open={this.state.SlipModal}  onClose={this.onCloseSlipModal} closeIcon={closeIcon}>
                <EchargeSlip eSlipUri={this.state.eSlipUri} showModal={this.eSlipModalCallback}/>
           </Modal>
            <div className="container-fluid ">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-tb-10">
                  <div className="">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-b10">
                        <Link to="#" onClick={() => { this.childPageClick('freeemi') }}>
                          <div className="rectangle-card">
                            <header className="w3-container">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                                <h4 className="pull-left align-left txnhead-term">
                                  Free EMI Wallet
                              </h4>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <h4 className="pull-right align-right txndate">
                                  {moment(new Date()).format('MMM YYYY')}
                                </h4>
                              </div>
                            </header>
                            <div className="devider-line"></div>
                            <div className="w3-container">
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">

                                <div className="col-md-6 pull-left align-left">
                                  <p className="txntitle">Terminals</p>
                                </div>
                                <div className="col-md-6 pull-right align-right">
                                  <p className="txntitle">Available Balance</p>
                                </div>

                              </div>
                              {this.state.terminalData.map((value, key) => {
                                return (
                                  <>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                      <div className="col-md-6 pull-left align-left">
                                        <p className="terminal">{this.state.terminalNames[key]} (Terminal {key + 1})</p>
                                      </div>
                                      <div className="col-md-6 pull-right align-right">
                                        <p className="txnval">
                                          <span className="inr-sign"> </span>
                                          <span id="terminalAmt">{this.state.terminalData[key].limitAvailable.split('.')[0]}</span>.
                                          <span className="smalltext">{this.state.terminalData[key].limitAvailable.split('.')[1]}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )
                              })
                              }
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-b10">
                        <div className="rectangle-card" onClick={()=>{this.showChargeSlipModal()}}>
                          <header className="w3-container">
                            {/* <div className="col-md-12"> */}
                            <div className="col-md-6 col-xs-6 ">
                              {" "}
                              <h4 className="txnhead">Last Txn</h4>
                            </div>
                            <div className="col-md-6 col-xs-6 ">
                              {" "}
                              <h4 className="pull-right align-right txndate">
                                {moment(
                                  this.state.lastTransaction.dateTime
                                ).format("DD MMM YYYY, hh:mm a")}
                              </h4>
                            </div>
                            {/* </div>  */}
                          </header>
                          <div className="devider-line"></div>
                          <div className="w3-container">
                            <div className="col-md-6 col-xs-6 pull-left align-left">
                              <div className="pull-left">
                                <p className="txnid">
                                  TXN ID :
                                <span style={{ wordBreak: 'break-all' }}> {this.state.lastTransaction.txnId}</span>
                                </p>
                                <p style={{ fontSize: "12px", display: 'inline-flex' }}>
                                  <img className="mastercard-image" src={getCardLabelIcons(this.state.lastTransaction.cardLabel)} style={{ paddingRight: '3px' }} />
                                  {/* <span id="cardno" style={{ fontSize: '12px' }}> */}
                                  {this.state.lastTransaction.maskCardNumber}
                                  {/* </span> */}
                                -{' '}
                                  {/* <span id="transtype" style={{ fontSize: '12px' }}> */}
                                  {this.state.lastTransaction.transactionType}
                                  {/* </span> */}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6 col-xs-6 pull-right align-right">
                              <p className="txntitle">Transaction Amount</p>
                              <p className="txnval" style={this.state.orgamt}>
                                <span className="inr-sign"> </span>
                                <span>
                                  {" "}
                                  {
                                    this.state.lastTransaction.amount.split(
                                      "."
                                    )[0]
                                  }
                                </span>
                              .
                              <span className="smalltext">
                                  {
                                    this.state.lastTransaction.amount.split(
                                      "."
                                    )[1]
                                  }
                                </span>
                              </p>
                            </div>
                          </div>

                          {/* </Link> */}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-b10">
                        <Link to="#" onClick={() => { this.childPageClick('tytrans') }}>
                          <div className="rectangle-card">
                            <header className="w3-container ">
                              {/* <div className="col-md-12"> */}
                              <div className="col-md-6 col-xs-6">
                                {" "}
                                <h4 className="pull-left align-left txnhead">
                                  Today's Summary
                            </h4>
                              </div>
                              <div className="col-md-6 col-xs-6">
                                {" "}
                                <h4 className="pull-right align-right txndate">
                                  {moment(this.state.todayTxn.dateTime).format(
                                    "DD MMM YYYY, hh:mm a"
                                  )}
                                </h4>
                              </div>
                              {/* </div>*/}
                            </header>
                            <div className="devider-line"></div>
                            {/* <Link className="" to="/admin/ipos-todaytrans"> */}

                            <div className="w3-container">
                              <div className="col-md-6 pull-left align-left">
                                <div className="textcenter-left">
                                  <p className="txntitle">Transaction Count</p>
                                  <p className="txnval" style={this.state.orglbl}>
                                    <span>{this.state.todayTxn.count}</span>

                                    <span className="smalltext"> Txns</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 pull-right align-right">
                                <p className="txntitle">Transaction Amount</p>
                                <p className="txnval" style={this.state.orgamt}>
                                  {" "}
                                  <span className="inr-sign"> </span>
                                  <span>
                                    {this.state.todayTxn.txnAmount.split(".")[0]}
                                  </span>
                              .
                              <span className="smalltext">
                                    {this.state.todayTxn.txnAmount.split(".")[1]}
                                  </span>
                                </p>
                              </div>
                            </div>

                            {/* </Link> */}
                          </div>
                        </Link>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-b10">
                        <Link to="#" onClick={() => { this.childPageClick('settled') }}>
                          <div className="rectangle-card">
                            <header className="w3-container">
                              {/* <div className="col-md-12"> */}
                              <div className="col-md-6 col-xs-6 ">
                                {" "}
                                <h4 className="txnhead">Last Settlement</h4>
                              </div>
                              <div className="col-md-6 col-xs-6 ">
                                {" "}
                                <h4 className="pull-right align-right txndate">
                                  { this.state.lastSettlement.dateTime.includes("NA")?"Not Applicable":moment(
                                    this.state.lastSettlement.dateTime
                                  ).format("DD MMM YYYY, hh:mm a")}
                                </h4>
                              </div>
                              {/* </div> */}
                            </header>
                            <div className="devider-line"></div>
                            {/* <Link className="" to="/admin/ipos-settled"> */}

                            <div className="w3-container">
                              <div className="col-md-6 pull-left align-left">
                                <div className="textcenter-left">
                                  <p className="txntitle">Transaction Count</p>
                                  <p className="txnval" style={this.state.orglbl}>
                                    <span id="transCount">
                                      {this.state.lastSettlement.count}
                                    </span>
                                    <span className="smalltext"> Txns</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 pull-right align-right">
                                <p className="txntitle">Settlement Amount</p>
                                <p className="txnval" style={this.state.orglbl}>
                                  <span className="inr-sign"> </span>
                                  <span id="settleAmt">
                                    {
                                      this.state.lastSettlement.amount.split(
                                        "."
                                      )[0]
                                    }
                                  </span>
                              .
                              <span className="smalltext">
                                    {
                                      this.state.lastSettlement.amount.split(
                                        "."
                                      )[1]
                                    }
                                  </span>
                                </p>
                              </div>
                            </div>

                            {/* </Link> */}
                          </div>
                        </Link>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <Link to="#" onClick={() => { this.childPageClick('unsettled') }}>
                          <div className="rectangle-card">
                            <header className="w3-container">
                              {/* <div className="col-md-12"> */}
                              <div className="col-md-6 col-xs-6 ">
                                {" "}
                                <h4 className="txnhead"> Unsettled Txns</h4>
                              </div>
                              <div className="col-md-6 col-xs-6 ">
                                {" "}
                                <h4 className="pull-right align-right txndate">
                                  {moment(this.state.unSettledTxn.dateTime).format(
                                    "DD MMM YYYY, hh:mm a"
                                  )}
                                </h4>
                              </div>
                              {/* </div>     */}
                            </header>
                            {/* <Link className="" to="/admin/ipos-unsettled"> */}
                            <div className="devider-line"></div>

                            <div className="w3-container">
                              <div className="col-md-6 pull-left align-left">
                                <div className="textcenter-left">
                                  <p className="txntitle">Transaction Count</p>
                                  <p className="txnval" style={this.state.orglbl}>
                                    <span>{this.state.unSettledTxn.count}</span>
                                    <span className="smalltext"> Txns</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 pull-right align-right">
                                <p className="txntitle">Unsettled Amount</p>
                                <p className="txnval" style={this.state.orgamt}>
                                  {" "}
                                  <span className="inr-sign"> </span>
                                  <span>
                                    {
                                      this.state.unSettledTxn.amount.split(
                                        "."
                                      )[0]
                                    }
                                  </span>
                              .
                              <span className="smalltext">
                                    {
                                      this.state.unSettledTxn.amount.split(
                                        "."
                                      )[1]
                                    }
                                  </span>
                                </p>
                              </div>
                            </div>

                            {/* </Link> */}
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           </div> : null}
           {this.state.loader && <div className="fixed-content">
          <BeatLoader
            css={override}
            sizeUnit={"px"}
            size={15}
            color={'#123abc'}
            loading={this.state.loader}
          />
        </div>}

      </>
    );
  }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(IposDashboard);
